module.exports = __webpack_public_path__ + "static/media/tq11.9272dab0.jpg";